import 'twin.macro';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@teetsh/app/src/components/Buttons/Button';
import { Csv } from '@teetsh/app/src/containers/Eleves/Import/File/csv';
import { CardAttachment as Attachments } from '@teetsh/app/src/components/Attachments/CardAttachment';
import { useUploadAndParseElevesFile } from '@teetsh/app/src/queries/eleves/useUploadAndParseElevesFile';

interface Props {
  setCsv: (csv: Csv) => void;
}

export function Upload(props: Props) {
  const { setCsv } = props;
  const { t } = useTranslation(['eleve', 'common']);
  const [currentCsv, setCurrentCsv] = useState<Csv | null>(null);
  const { upload } = useUploadAndParseElevesFile();
  const [uploadData, setUploadData] = useState<{
    state: 'default' | 'loading' | 'error' | 'success';
    fileName?: string | null;
  }>({
    state: 'default',
    fileName: null,
  });

  return (
    <div tw="flex flex-col gap-4 w-full">
      <div tw="flex flex-col gap-2">
        <div tw="relative w-full">
          <Attachments
            uploadedFileName={uploadData.fileName}
            acceptOnly="csv"
            state={uploadData.state}
            onReset={() => {
              setCurrentCsv(null);
              setUploadData({ state: 'default', fileName: null });
            }}
            handleError={({ message }) => {
              // eslint-disable-next-line no-console
              console.error(message);
              setUploadData(prev => ({ ...prev, state: 'error' }));
            }}
            handleUploadAttachment={({ file }) => {
              setUploadData({ state: 'loading', fileName: file.name });
              return upload({ file })
                .then(v => {
                  setCurrentCsv({
                    headers: v.meta.fields,
                    rows: v.data,
                  });
                  setUploadData(prev => ({ ...prev, state: 'success' }));
                })
                .catch(error => {
                  setUploadData(prev => ({ ...prev, state: 'error' }));
                  throw error;
                });
            }}
          />
        </div>
        <p tw="text-sm text-neutral-quiet italic text-center">
          {t('eleve:import.weKeepYourDataSafe')}
        </p>
      </div>
      <div tw="flex justify-end">
        <Button
          intent="primary"
          disabled={!currentCsv}
          onClick={() => {
            if (currentCsv) {
              setCsv(currentCsv);
            }
          }}
        >
          {t('common:buttons.next')}
        </Button>
      </div>
    </div>
  );
}
